import React, { useState } from 'react';
import RequestRepair from '../components/RequestRepair/RequestRepair';
import OrderReceived from '../components/OrderReceived/OrderReceived';
import FloatingButton from '../components/FloatingButton/FloatingButton';

export default function RefundCancellationPolicyPage() {
  const [showRepair, setShowRepair] = useState(false);
  const [showOrderReceived, setShowOrderReceived] = useState(false);
  const [orderId, setOrderId] = useState(null);

  const handleRepairSubmit = (submittedOrderId) => {
    setOrderId(submittedOrderId);
    setShowRepair(false);
    setShowOrderReceived(true);
  };

  return (
    <>
      <div className="policy-page-wrapper">
        {/* Background Ambient Elements */}
        <div className="policy-bg-glow" aria-hidden="true" />
        <div className="policy-bg-dots-left" aria-hidden="true" />
        <div className="policy-bg-dots-right" aria-hidden="true" />

        <div className="policy-container">
          <header className="policy-header">
            <div className="policy-badge">
              <span className="star-icon">★</span>
              <span>REFUND &amp; CANCELLATION</span>
            </div>

            <h1>
              Refund &amp; Cancellation <span className="gold-text">Policy</span>
            </h1>

            {/* Gold Diamond Divider */}
            <div className="heading-divider" aria-hidden="true">
              <div className="divider-line" />
              <div className="divider-diamond" />
              <div className="divider-line" />
            </div>

            <p className="subnote">Independent Repair Service • Not affiliated with any brand</p>
            <p className="effective-date">Effective Date: 07/08/2026</p>
          </header>

          <div className="policy-content">
            <p className="intro">
              At DoorStep Maintenance &amp; Repair (DSMR), we strive to deliver transparent, prompt, and reliable repair services. This Refund &amp; Cancellation Policy explains the conditions under which service appointments may be cancelled, modified, or refunded. By scheduling a service with DSMR, you agree to these terms.
            </p>

            <section className="policy-section">
              <h2>1. Service Cancellation by Customer</h2>
              <ul>
                <li><strong>Free Cancellation Window:</strong> Customers may cancel or reschedule a service appointment free of charge by informing us at least <strong>4 hours</strong> prior to the scheduled time.</li>
                <li><strong>Late Cancellation / Technician Compensation Fee:</strong> If a cancellation is requested less than 4 hours before the appointment, or after a technician has been dispatched, a <strong>₹599 technician compensation fee</strong> will be charged to cover travel costs, dispatch coordination, and lost technician time.</li>
                <li><strong>Doorstep Denial Fee:</strong> If a technician arrives at your doorstep after you previously confirmed the repair charges and appointment over phone/WhatsApp/website, and you subsequently refuse the service upon arrival, the ₹599 technician compensation fee remains applicable.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>2. Service Cancellation by DSMR Solutions</h2>
              <ul>
                <li>In rare circumstances (unforeseen traffic emergencies, severe weather, component stock unavailability, or safety concerns), DSMR may need to reschedule or cancel a booking.</li>
                <li>If DSMR cancels a booking, no charges or fees will apply to the customer. You will be offered immediate priority rescheduling or a full refund of any advance deposit paid.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. Refund Policy &amp; Non-Refundable Scenarios</h2>
              <ul>
                <li><strong>Completed Repairs:</strong> Once a repair or part replacement has been completed successfully and accepted by the customer upon testing, repair labor charges and part costs are non-refundable. Post-repair defects are governed by our <a href="/warranty-policy" style={{ color: '#C99E54', textDecoration: 'underline' }}>Warranty Policy</a> through repair or replacement.</li>
                <li><strong>Advance Part Deposits:</strong> If an advance payment was collected for sourcing a specialized component that subsequently becomes unavailable or unserviceable, 100% of the advance deposit will be refunded to the customer.</li>
                <li><strong>Unrepairable Devices:</strong> If a device is declared unrepairable after diagnostic assessment, no repair fee is charged; however, diagnostic or technician travel fees may apply as communicated during booking.</li>
                <li><strong>Data Loss:</strong> Fees paid for diagnostic work or data recovery attempts are non-refundable regardless of recovery yield, due to the labor-intensive nature of hardware recovery.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. No-Show Policy</h2>
              <ul>
                <li>If our technician arrives at the designated location at the agreed time and the customer is unavailable, unreachable via phone, or fails to provide access within 15 minutes of arrival, the appointment will be categorized as a "No-Show."</li>
                <li>A ₹599 technician compensation fee will be billed for No-Show appointments before any future booking can be scheduled.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Refund Processing Timelines &amp; Methods</h2>
              <ul>
                <li><strong>Approved Refunds:</strong> All eligible refunds will be initiated within 24–48 hours of approval.</li>
                <li><strong>Settlement Timelines:</strong>
                  <ul>
                    <li>UPI Payments (GPay, PhonePe, Paytm): 1–3 business days.</li>
                    <li>Debit / Credit Cards &amp; Net Banking: 3–7 business days (depending on your issuing bank).</li>
                    <li>Cash Payments: Refunded via bank transfer or UPI.</li>
                  </ul>
                </li>
                <li>Refunds will be credited strictly back to the original source account from which payment was received.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>6. Contact for Cancellation &amp; Refund Requests</h2>
              <p>To request a cancellation, appointment change, or refund status update, please contact our support team:</p>
              <div className="contact-info">
                <p><strong>DSMR Solutions — Customer Care</strong></p>
                <p>Website: dsmrsolutions.in</p>
                <p>Phone: +91.8700319769</p>
                <p>Email: support@dsmrsolutions.in</p>
              </div>
            </section>
          </div>
        </div>

        {showRepair && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.4)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <RequestRepair
              isModal={true}
              onClose={() => setShowRepair(false)}
              onSubmit={handleRepairSubmit}
            />
          </div>
        )}

        {showOrderReceived && (
          <OrderReceived
            orderId={orderId}
            onClose={() => setShowOrderReceived(false)}
          />
        )}



        <style>{`
          .policy-page-wrapper {
            min-height: 100vh;
            background: linear-gradient(135deg, #f9f4ee 0%, #fbf6f1 35%, #fdf8f5 70%, #fdf9f4 100%);
            padding: 8rem 1.5rem 4rem 1.5rem;
            position: relative;
            overflow: hidden;
            font-family: 'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          }

          .policy-bg-glow {
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            width: 900px;
            height: 480px;
            background: radial-gradient(ellipse at center, rgba(235, 205, 155, 0.35) 0%, rgba(250, 246, 240, 0) 70%);
            pointer-events: none;
            z-index: 0;
          }

          .policy-bg-dots-left {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 300px;
            background-image: radial-gradient(#C99E54 1.4px, transparent 1.4px);
            background-size: 22px 22px;
            opacity: 0.25;
            mask-image: linear-gradient(to right, rgba(0,0,0,0.8), transparent);
            -webkit-mask-image: linear-gradient(to right, rgba(0,0,0,0.8), transparent);
            pointer-events: none;
          }

          .policy-bg-dots-right {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            width: 300px;
            background-image: radial-gradient(#C99E54 1.4px, transparent 1.4px);
            background-size: 22px 22px;
            opacity: 0.25;
            mask-image: linear-gradient(to left, rgba(0,0,0,0.8), transparent);
            -webkit-mask-image: linear-gradient(to left, rgba(0,0,0,0.8), transparent);
            pointer-events: none;
          }

          .policy-container {
            max-width: 860px;
            margin: 0 auto;
            background: linear-gradient(135deg, #fefaf4 0%, #fdf9f3 35%, #fefaf6 70%, #fdf9f6 100%);
            border-radius: 24px;
            border: 1px solid rgba(201, 158, 84, 0.25);
            box-shadow: inset 0 1px 2px rgba(255,255,255,.95), 0 0 0 1px rgba(255,233,194,.45), 0 10px 24px rgba(191,160,110,.10), 0 14px 35px rgba(180,150,100,.09), 0 50px 100px rgba(180,150,100,.06);
            overflow: hidden;
            position: relative;
            z-index: 1;
          }

          .policy-header {
            background: linear-gradient(180deg, #FFFFFF 0%, #FAF5EE 100%);
            color: #0F172A;
            padding: 3rem 2.5rem 2rem 2.5rem;
            text-align: center;
            border-bottom: 1px solid rgba(201, 158, 84, 0.2);
          }

          .policy-badge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 0.75rem;
            font-weight: 700;
            letter-spacing: 1.5px;
            color: #C99E54;
            background: rgba(201, 158, 84, 0.08);
            border: 1px solid rgba(201, 158, 84, 0.3);
            border-radius: 30px;
            padding: 6px 16px;
            margin-bottom: 1rem;
            text-transform: uppercase;
          }

          .star-icon {
            font-size: 0.85rem;
            color: #F0B040;
          }

          .policy-header h1 {
            font-size: 2.75rem;
            font-weight: 800;
            color: #0F172A;
            margin: 0 0 0.5rem 0;
            letter-spacing: -0.5px;
          }

          .gold-text {
            color: #C98E32;
            background: linear-gradient(135deg, #D99215 0%, #B88228 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .heading-divider {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            margin: 1rem 0 1.25rem 0;
          }

          .divider-line {
            height: 1px;
            width: 60px;
            background: linear-gradient(90deg, transparent, #C99E54, transparent);
          }

          .divider-diamond {
            width: 7px;
            height: 7px;
            background: #C99E54;
            transform: rotate(45deg);
          }

          .subnote {
            margin: 0 0 0.4rem 0;
            color: #64748B;
            font-size: 0.98rem;
            font-weight: 500;
          }

          .effective-date {
            font-size: 0.95rem;
            color: #94A3B8;
            margin: 0;
            font-weight: 500;
          }

          .policy-content {
            padding: 3rem 2.5rem;
            line-height: 1.8;
            color: #334155;
          }

          .intro {
            font-size: 1.08rem;
            margin-bottom: 1.5rem;
            padding: 1.5rem;
            background: rgba(201, 158, 84, 0.06);
            border-left: 4px solid #C99E54;
            border-radius: 0 12px 12px 0;
            color: #1E293B;
          }

          .policy-section {
            margin-bottom: 2.75rem;
          }

          .policy-section h2 {
            color: #0F172A;
            font-size: 1.45rem;
            font-weight: 700;
            margin-bottom: 1rem;
            padding-bottom: 0.5rem;
            border-bottom: 2px solid rgba(201, 158, 84, 0.18);
            display: flex;
            align-items: center;
          }

          .policy-section p {
            margin-bottom: 1rem;
            font-size: 1.02rem;
            color: #334155;
          }

          .policy-section ul,
          .policy-section ol {
            margin: 1rem 0 1.25rem 0;
            padding-left: 1.6rem;
          }

          .policy-section li {
            margin-bottom: 0.6rem;
            font-size: 1.02rem;
            color: #334155;
          }

          .contact-info {
            background: linear-gradient(135deg, #FFFDF9 0%, #FDF8F0 100%);
            padding: 1.75rem;
            border-radius: 14px;
            border: 1px solid rgba(201, 158, 84, 0.25);
            box-shadow: 0 4px 15px rgba(201, 158, 84, 0.06);
            margin-top: 1.25rem;
          }

          .contact-info p {
            margin: 0.5rem 0;
            font-size: 1.02rem;
          }

          .contact-info strong {
            color: #0F172A;
          }

          @media (max-width: 768px) {
            .policy-page-wrapper {
              padding: 6.5rem 1rem 2rem 1rem;
            }

            .policy-container {
              border-radius: 16px;
            }

            .policy-header {
              padding: 2.25rem 1.5rem 1.5rem 1.5rem;
            }

            .policy-header h1 {
              font-size: 2.1rem;
            }

            .policy-content {
              padding: 2rem 1.5rem;
            }

            .intro {
              font-size: 1rem;
              padding: 1.15rem;
            }

            .policy-section h2 {
              font-size: 1.3rem;
            }

            .policy-section p,
            .policy-section li {
              font-size: 0.98rem;
            }
          }

          @media (max-width: 480px) {
            .policy-page-wrapper {
              padding: 5.5rem 0.5rem 1.5rem 0.5rem;
            }

            .policy-header {
              padding: 1.75rem 1rem 1.25rem 1rem;
            }

            .policy-header h1 {
              font-size: 1.85rem;
            }

            .policy-content {
              padding: 1.5rem 1rem;
            }
          }
        `}</style>
      </div>
    </>
  );
}
